<template>
  <div>
    <b-container class="" fluid>
      <b-row>
        <b-col class="">
          <h4>Use Referrals to get discounts</h4>
          <p class="alert-info rounded px-3 py-3">
            The referral discount is a discount for users who referred their
            friends to quicktest using their referral link on their
            <b-link :to="{ name: 'updateprofile' }">dashboard profile.</b-link>
            You get double the number of unused referrals you have as a
            discount. If you have 5 unused referrals, you will have a 10%
            discount on your next upgrade. Your used up referrals will not count
            on your next upgrade.
          </p>
          <div class="text-center mt-5">
            <h5 class="mx-auto">Your Referrals</h5>
            <b-skeleton-wrapper class="text-center">
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <h6 class="mx-auto">
                {{ referrals.length }} user{{ referrals.length > 1 ? "s" : "" }}
                referred
              </h6>
            </b-skeleton-wrapper>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-0 p-1">
          <div class="text-center list-heads pt-1">
            <p class="head-p">S/N</p>
            <p class="head-p">Name</p>
            <p class="head-p">Email</p>
            <p class="head-p">Date referred</p>
            <p class="head-p">Status</p>
          </div>

          <b-skeleton-wrapper
            class="text-center mt-3"
            :loading="loading"
          >
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>

          <div v-if="!loading">
            <referralsList
              class="mt-2 maxres"
              v-for="(referral, index) in usereferrals"
              :sn="index + 1"
              :referral="referral"
              :key="index"
              :page="pages"
              :interval="intervalnum"
            />
          </div>
          

          <div class="text-center vmore">
            <b-row>
              <b-col class="text-left p-0 m-0">
                <p>
                  Showing {{ intervalnum * pages - intervalnum + 1 }} -
                  {{ endnum > endss ? endss : endnum }}
                </p>
              </b-col>
              <b-col class="text-right p-0 m-0 button-pager-group">
                <b-button-group size="xs">
                  <b-button
                    v-for="(page, index) in ranger"
                    :key="index"
                    :page="page"
                    :class="[pages == page ? 'active-page-btn' : '']"
                    @click="newPage(page)"
                    class="ml-1 page-buttons"
                    size="xs"
                    variant="outline-dark"
                    >{{ page }}</b-button
                  >
                </b-button-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import referralsList from "@/components/lists/referralsList";
import { mapState, mapActions } from "vuex";
// import store from "@/store";

export default {
  components: {
    referralsList
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      loading: false
    };
  },
  mounted(){
    this.fetchData();
  },
  methods: {
    ...mapActions("dashboard", ["fetchReferrals"]),
    async fetchData() {
      this.loading = true;
      try {
        await this.fetchReferrals();
        this.loading = false;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    newPage(page) {
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    }
  },

  computed: {
    ...mapState({
      referrals: state => state.dashboard.referrals
    }),

    usereferrals() {
      return this.referrals.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.referrals.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.referrals.length / this.intervalnum);
      return ranger;
    },
    retrieving() {
      //let trid = this.$route.params.trackid;

      let curres = this.referrals.length;
      //this.referrals = curres;

      if (curres <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.allrewr {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row nowrap;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.maxres {
  border-radius: 5px 5px;
}

.maxres:hover {
  background-color: #eeeeee;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.spinver {
  width: 7rem;
  height: 7rem;
}
.head-p {
  width: 20%;
  padding: 2px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.75rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
